export default __webpack_public_path__ + "static/media/decline-status.5fcb37b6.svg";